import { module } from 'modujs';
import { $html } from '../utils/dom';

export default class Header extends module {
    static get settings() {
        return {
            CLASS_STICKY: 'is-sticky'
        }
    }

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$sticky = this.$('sticky')[0]

        // Vars
        this.isSticky = false
        this.stickyIsLocked = false
        this.scrollTop = true

        this.events = {
            click: {
                "menu-toggler": "onMenuClick",
                "a11y-toggler": "onA11yClick"
            },
            mousemove: {
                'sticky': 'setSticky'
            },
            mouseenter: {
                'sticky': 'lockSticky'
            },
            mouseleave: {
                'sticky': 'unlockSticky'
            }
        }
    }

    init() {
        this.updateStickyLock(true)
    }

    onMenuClick() {
        this.call('open', null, 'Menu')
    }

    onA11yClick() {
        if ($html.dataset.theme === 'standard') {
            $html.dataset.theme = 'light'
            localStorage.setItem("a11y", "light");
        } else if ($html.dataset.theme === 'light') {
            $html.dataset.theme = 'standard'
            localStorage.setItem("a11y", "standard");
        }
    }

    setSticky(sticky = true) {
        if (this.isSticky === sticky || this.stickyIsLocked || this.scrollTop) {
            return
        }

        this.$sticky.setAttribute('aria-hidden', !sticky)
        this.$sticky.classList.toggle(Header.settings.CLASS_STICKY, sticky)
        this.isSticky = sticky
    }

    lockSticky() {
        this.setSticky()
        this.stickyIsLocked = true
    }

    unlockSticky() {
        this.stickyIsLocked = false
    }

    updateStickyLock(scrollTop) {
        this.scrollTop = scrollTop
    }

    resetSticky() {
        this.setSticky(false)
        this.unlockSticky()
    }
}